import propertyScanLogo from '@/assets/propertyscan-logo.png';

export function SidebarHeader({ collapsed = false }: { collapsed?: boolean }) {
    return (
        <div className="flex h-16 items-center justify-center border-b border-ink-100 px-2">
            <img
                src={propertyScanLogo}
                alt="KMI PropertyScan"
                // The rail is 4rem wide: shrink the mark so it doesn't crowd it.
                className={collapsed ? 'h-8 w-8 object-contain' : 'h-10 w-auto'}
            />
        </div>
    );
}
